import PropType from 'prop-types';
import { Information } from '../../../../assets/images';

export const ClaimingProcessGuides = ({ image, content }) => {
  return (
    <div className="claiming-guides-container">
      {image}
      {content}
      <Information className="claiming-guides-icon" />
    </div>
  );
};

ClaimingProcessGuides.propTypes = {
  image: PropType.node.isRequired,
  content: PropType.node.isRequired
};
